import React, { Component, Fragment } from "react";
import { withRouter, Link} from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, saveState, deleteState } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { Pagination } from "../Pagination/Pagination";
import {getMessagemErro} from "../../utils/erro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DatePicker , { registerLocale } from "react-datepicker";
import pt_br from "date-fns/locale/pt-BR";
import { faClipboardCheck, faDownload, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { ButtonBack } from "../Button/Back";
import SelectSearch from "../UI/SelectSearch/SelectSearch";
import api from "../../services/api";
import { baixarArquivo } from "../../utils/downloadUtil";

import './AutoCadastroUsuario.css';
import { FEDERAL, ESTADUAL, MUNICIPAL } from "../../providers/constEsferasAdministrativas";
import { SITUACAO_AUTO_CADASTRO_USUARIO_AGUARDANDO_ASSINATURA, SITUACAO_AUTO_CADASTRO_USUARIO_EM_ANALISE, SITUACAO_AUTO_CADASTRO_USUARIO_APROVADA, SITUACAO_AUTO_CADASTRO_USUARIO_RASCUNHO, SITUACAO_AUTO_CADASTRO_USUARIO_REPROVADA } from "../../providers/constSituacoesAutoCadastroUsuario";

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando, saveState, deleteState }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
		filters: state.filterStore,
	}
}

registerLocale("pt_br", pt_br);
export const AutoCadastroUsuarioList =

// router
withRouter(
// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(
	class extends Component {
	
		constructor(props){
			super(props);
			this.initialState = {
				criterioPesquisa: {
					cpf: '',
					cnpj: '',
					orgao: '',
					situacao: '',
					esferaAdministrativa: '',
					dataInicial: '',
					dataFinal: '',
				},
				orgaos: [],
				situacoes: [SITUACAO_AUTO_CADASTRO_USUARIO_AGUARDANDO_ASSINATURA, SITUACAO_AUTO_CADASTRO_USUARIO_APROVADA, SITUACAO_AUTO_CADASTRO_USUARIO_EM_ANALISE, SITUACAO_AUTO_CADASTRO_USUARIO_RASCUNHO, SITUACAO_AUTO_CADASTRO_USUARIO_REPROVADA],
				esferasAdministrativas: [ESTADUAL, FEDERAL, MUNICIPAL],
				carregandoOrgaos: false,
				resultadoPesquisa: {},
				pesquisaExecutada: false,
				botoesHabilitados : true,
			};
			this.state = this.initialState;
			this.handleInputChange = this.handleInputChange.bind(this);
			this.handleEsferaAdministrativaChange = this.handleEsferaAdministrativaChange.bind(this);
			this.carregarOrgaos = this.carregarOrgaos.bind(this);
			this.pesquisar = this.pesquisar.bind(this);
			this.executaPesquisaPaginada = this.executaPesquisaPaginada.bind(this);
			this.limparPesquisa = this.limparPesquisa.bind(this);
			this.mostraRelatorioCSV = this.mostraRelatorioCSV.bind(this);
			this.mostraRelatorioPDF = this.mostraRelatorioPDF.bind(this);
			this.executarPesquisaAnterior = this.executarPesquisaAnterior.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					
					<div style={{margin: "10px"}}>
						<h1>Solicitações de Cadastro de Usuário</h1>
					</div>
					
					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			
			const user = this.props.user;

			if(user.isAdministrador){
				this.carregarOrgaos('');
			}

			if (!this.props.location.state?.resetSearch) {
				this.executarPesquisaAnterior();
			}
		}

		renderForm() {
			const user = this.props.user;

			const { 
				criterioPesquisa, resultadoPesquisa, pesquisaExecutada, orgaos, situacoes, esferasAdministrativas, 
				carregandoOrgaos, 
			} = this.state;
			const { content } = resultadoPesquisa;
			const exibeBotoes = content && content.length > 0;
			const { cpf, cnpj, orgao, situacao, esferaAdministrativa, dataInicial, dataFinal } = criterioPesquisa;

			return(
				<div className="container-fluid">

					<div className="br-form">
						<div className="row">

							<div className="col-sm-2">
								<div className="field">
									<div className="input">
										<label>CPF Usuário:</label>
										<input type="text" name="cpf" 
											value={cpf}  
											onChange={this.handleInputChange} maxLength={11}/>
										
									</div>
								</div>
							</div>
							{user.isAdministrador  &&
								<Fragment>
									<div className="col-sm-2">
										<div className="field">
											<div className="input">
												<label>CNPJ Órgão:</label>
												<input type="text" name="cnpj" 
													value={cnpj}  
													onChange={this.handleInputChange} maxLength={14}/>
												
											</div>
										</div>
									</div>
							
									<div className="col-sm-2">
										<div className="field">
											<div className="input">
												<label>Esfera Administrativa:</label>
												<SelectSearch
													id="esferaAdministrativa"
													name="esferaAdministrativa"
													includeAllOption={true}
													allOptionName="Todas"
													options={esferasAdministrativas.map(esfera => ({value: esfera.codigo, label: esfera.nome}))}
													onChange={this.handleEsferaAdministrativaChange}
													value={esferaAdministrativa}	
												/>
											</div>
										</div>
									</div>
								
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label>Órgão:</label>
												{ carregandoOrgaos === false &&
													<SelectSearch
														id="orgao"
														name="orgao"
														options={orgaos.map(orgao => ({value: orgao.id, label: orgao.nome}))}
														onChange={this.handleInputChange}
														includeAllOption={true}
														value={orgao}	
													/>
												}
												{ carregandoOrgaos === true  && 
													<button className="br-button is-secondary is-circle is-loading" type="button"/>
												}
											</div>
										</div>
									</div>
								</Fragment>
							}
						</div>
						
						<div className="row">	
							<div className="col-sm-2">
								<div className="field">
									<div className="input">
										<label>Situação do Cadastro:</label>
										<SelectSearch
											id="situacao"
											name="situacao"
											options={situacoes.map(situacao => ({value: situacao.id, label: situacao.nome}))}
											onChange={this.handleInputChange}
											includeAllOption={true}
											allOptionName="Todas"
											value={situacao}	
										/>
									</div>
								</div>
							</div>

							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Data Inicial do Cadastro:</label>
										<DatePicker locale="pt_br" dateFormat="dd/MM/yyyy" selected={dataInicial} onChange={data => {
												const criterioPesquisa = this.state.criterioPesquisa;
												criterioPesquisa['dataInicial'] = data;
												this.setState({criterioPesquisa})}} />
									</div>
								</div>
							</div>

							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Data Final do Cadastro:</label>
										<DatePicker locale="pt_br" dateFormat="dd/MM/yyyy" selected={dataFinal} onChange={data => {
												const criterioPesquisa = this.state.criterioPesquisa;
												criterioPesquisa['dataFinal'] = data;
												this.setState({criterioPesquisa})}} />
									</div>
								</div>
							</div>
						</div>

						<div className="actions-button">
							<div className="actions justify-content-start">
								<button type="button" className="button is-primary" onClick={() => this.pesquisar()} disabled={!this.state.botoesHabilitados}>Pesquisar</button>
								{exibeBotoes === true &&	<button type="button" className="button is-secondary" onClick={this.mostraRelatorioPDF} disabled={!this.state.botoesHabilitados}>Relatório PDF</button>}
								{exibeBotoes === true &&	<button type="button" className="button is-secondary" onClick={this.mostraRelatorioCSV} disabled={!this.state.botoesHabilitados}>Relatório CSV</button>}
								<button type="button" className="button is-secondary" onClick={() => this.limparPesquisa()} disabled={!this.state.botoesHabilitados}>Limpar</button>
								<ButtonBack disabled={!this.state.botoesHabilitados}/>
							</div>
						</div>
					
						{(content && content.length > 0) &&	
							<div className="br-table">						
								<div className="table">
									<table>
										<thead>
											<tr>
												<th scope="col">CNPJ/Nome</th>
												<th scope="col">Esfera</th>
												<th scope="col">Siape</th>
												<th scope="col">CPF Usuário</th>
												<th scope="col">Nome Usuário</th>
												<th scope="col">Data Cadastro</th>
												<th scope="col">Situação</th>
												<th scope="col">Data análise</th>
												<th scope="col">Analisado por</th>
												<th className="text-center" scope="col">Ações</th>
											</tr>
										</thead>
										
										<tbody>
											{ content.map((autoCadastroUsuario, index) =>
													<tr key={index} >
														<td>{autoCadastroUsuario.cnpjOrgaoFormatado} <br/> {autoCadastroUsuario.nomeOrgao}</td>
														<td>{autoCadastroUsuario.nomeEsferaAdministrativaOrgao}</td>
														<td>{autoCadastroUsuario.siape ? 'Sim' : 'Não'}</td>
														<td>{autoCadastroUsuario.cpfUsuarioFormatado} </td>
														<td>{autoCadastroUsuario.nomeUsuario} </td>
														<td>{autoCadastroUsuario.dataCriacao} </td>
														<td>{autoCadastroUsuario.nomeSituacao}</td>
														<td>{autoCadastroUsuario.dataAnalise}</td>
														<td>{autoCadastroUsuario.nomeAnalista}</td>
														<td className="text-center">
															<div className="actions">


																{ autoCadastroUsuario.analisePermitida &&
																	<Link to={`/user-self-registration/approve/${autoCadastroUsuario.id}`}>
																		<button type="button" 
																				disabled={!this.state.botoesHabilitados}  
																				title="Analisar a solicitação de cadastro de usuário">
																			<span className="sr-only">Analisar a solicitação de cadastro de usuário</span>
																			<FontAwesomeIcon icon={faClipboardCheck} style={{color: "#1351b4"}} />
																		</button>
																	</Link>
																}

																{ autoCadastroUsuario.visualizacaoTermoResponsabilidadePermitida &&
																	<button type="button" onClick={() => this.baixarTermoResponsabilidadePDF(autoCadastroUsuario.id)}  
																			disabled={!this.state.botoesHabilitados}  
																			title="Baixar o termo de responsabilidade">
																		<span className="sr-only">Baixar o termo de responsabilidade</span>
																		<FontAwesomeIcon icon={faDownload} style={{color: "#1351b4"}} />
																	</button>
																}

																{ autoCadastroUsuario.visualizacaoPermitida &&
																	<Link to={`/user-self-registration/view/${autoCadastroUsuario.id}`}>
																		<button type="button" disabled={!this.state.botoesHabilitados} title="Visualizar a solicitação de cadastro de usuário">
																			<span className="sr-only">Visualizar</span>
																			<FontAwesomeIcon icon={faMagnifyingGlass} style={{color: "#1351b4"}} />
																		</button>
																	</Link>
																}
																
															</div>
														</td>
													</tr>
												)}
										</tbody>
									</table>
									<Pagination totalPaginas={resultadoPesquisa.totalPages} paginaAtual={resultadoPesquisa.number} onChangePage={this.executaPesquisaPaginada}/>
								</div>
							</div>
						}

						{(pesquisaExecutada && (! content || content.length === 0)) &&
							<div>
								Nenhuma solicitação encontrada com os critérios informados.
							</div>
						}
					</div>
				</div>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;

			const criterioPesquisa = this.state.criterioPesquisa;
			criterioPesquisa[nome] = valor;
			this.setState({ criterioPesquisa });
		}

		handleEsferaAdministrativaChange(evento){
			const esferaAdministrativa =  evento.target.value;

			const criterioPesquisa = this.state.criterioPesquisa;
			criterioPesquisa.esferaAdministrativa = esferaAdministrativa;
			criterioPesquisa.orgao = '';
			this.setState({ criterioPesquisa });

			this.carregarOrgaos(esferaAdministrativa);
		}

		carregarOrgaos(esferaAdministrativa) {
			this.setState({carregandoOrgaos: true})
			api.get(`/api/orgao/clientes?esferasAdministrativas=${[esferaAdministrativa]}`)
				.then(response => { 
					this.setState({orgaos: response.data }); 
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar os órgãos.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				}).finally(() => {
					this.setState({carregandoOrgaos: false});
				});
		}

		pesquisar (e){
			this.props.limpaMensagem();
			this.executaPesquisaPaginada(0);
			if (this.props.location.state?.resetSearch) {
				this.props.history.replace(this.props.location.pathname, {
					...this.props.location.state,
					resetSearch: false,
				  });
			}
		}

		executarPesquisaAnterior() {
            const lastState = this.props.filters[this.props.location.pathname];
 
            this.setState({
                ...this.initialState,
                ...lastState,
                pesquisaExecutada: false,
                resultadoPesquisa: []
            }, () => {
                if (lastState) {
                    const lastPage = lastState ? lastState?.resultadoPesquisa?.number : 0;
                    this.executaPesquisaPaginada(lastPage);
                }
            });
        }
 
		executaPesquisaPaginada (pagina){
			const {criterioPesquisa} = this.state;
			criterioPesquisa['pagina'] = pagina;
			const url = '/api/auto-cadastro-usuario/paginado';

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa
			}

			this.props.mostraAguardando();
			api(options)
				.then(response => { 
					this.setState({
						resultadoPesquisa: response.data,
						pesquisaExecutada : true,
					}, () => {
						this.props.saveState(this.state, this.props.location.pathname);
					}) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar as solicitações de cadastro de usuário. " + erro)
					this.props.exibeMensagemErro("Erro durante a execução da pesquisa")
				})
				.then(() => {
					this.props.escondeAguardando();
				});
		}

		limparPesquisa(){
			this.props.limpaMensagem();
			this.setState(
				{
					criterioPesquisa: {
						cpf: '',
						cnpj: '',
						orgao: '',
						situacao: '',
						esferaAdministrativa: '',
						dataInicial: '',
						dataFinal: '',
					},
					resultadoPesquisa: {},
					pesquisaExecutada: false,
					botoesHabilitados : true,
				}, () => {
					this.props.deleteState(this.state, this.props.location.pathname);
				}
			)
		}

		mostraRelatorioCSV(e){
			this.mostraRelatorio(e, 'csv');
		}

		mostraRelatorioPDF(e){
			this.mostraRelatorio(e, 'pdf');
		}

		mostraRelatorio(e, tipo){
			const { criterioPesquisa } = this.state;
			const url = `/api/auto-cadastro-usuario/${tipo}`;

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa,
				responseType: 'arraybuffer'
			}

			this.props.mostraAguardando();
			this.setState({botoesHabilitados : false});

			api(options)
				.then((response) => {
					baixarArquivo(new Blob([response.data]), `RelatorioSolicitacoesCadastroUsuario.${tipo}`);
				})				
				.catch(response => {
					const erro = {data: JSON.parse(Buffer.from(response.data).toString('utf8'))};
					const mensagemInicial = 'Não foi possível recuperar o relatório de solicitações de cadastro de usuário';
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
					this.setState({botoesHabilitados : true});
				});
		}

		baixarTermoResponsabilidadePDF(id){
            const options = {
				method: 'post',
				url: `/api/auto-cadastro-usuario/termo-responsabilidade/pdf/${id}`,
				responseType: 'arraybuffer'
			}

			this.props.mostraAguardando();
			this.setState({ botoesHabilitados : false });

			api(options)
				.then((response) => {
                    let nomeArquivo = 'TermoResponsabilidade.pdf';

					const contentDisposition = response['headers']['content-disposition'];
					if(contentDisposition) {
						nomeArquivo = contentDisposition.split("filename=")[1];
					}

                    baixarArquivo(new Blob([response.data]), nomeArquivo);
				})				
				.catch(response => {
					const erro = {data: JSON.parse(Buffer.from(response.data).toString('utf8'))};
					const mensagemInicial = 'Não foi possível recuperar o termo de responsabilidade';
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
					this.setState({botoesHabilitados : true});
				});
		}
	
	}

) // redux
); // router